import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

const useDevice = () => {
  const state = useContext(ResponsiveContext);
  return state.device;
};

export { useDevice };
//# sourceMappingURL=useDevice.es.js.map
